import { Heading } from '@lmig/lmds-react-typography';
import './NoAccessScreen.scss';
import { IconWarning } from '@lmig/lmds-react-icons';
import { Link } from '@lmig/lmds-react-link';

export default function NoAccessScreen(props: { tabName: string }) {
  return (
    <div id="activity-no-access-screen">
      <IconWarning size="48" aria-label="Access denied" className="activity-no-access-warning-icon" />
      <div className="activity-no-access-text-container">
        <Heading type="h4" className="activity-no-access-text-heading">
          Access required
        </Heading>
        <span className="activity-no-access-text-description">
          You may not have access to {props.tabName} information. Please contact Agency Interface Support at{' '}
          <Link href="tel:888-451-8414">888-451-8414</Link>.
        </span>
      </div>
    </div>
  );
}
